import type { EmbarcacaoAcomodacaoTipo, EmbarcacaoAcomodacoesField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const ACOMODACOES_ID = "acomodacoes";
export const ACOMODACOES_TITLE = "Acomodações";
export const ACOMODACOES_TEST_ID = "embarcacao-acomodacoes";
export const ACOMODACOES_LOADING_MESSAGE = "Carregando as Acomodações da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const ACOMODACOES_EMPTY_STATE = {
  title: "Nenhuma informação de Acomodações disponível",
  description:
    "Assim que houver dados de acomodação para esta embarcação, eles aparecerão nesta seção.",
};

/** Os campos gerais da seção, na ordem do AC2. A data da seção vai no cabeçalho. */
export const ACOMODACOES_FIELDS: readonly DetailFieldDefinition<EmbarcacaoAcomodacoesField>[] = [
  { key: "possuiEnfermaria", label: "Possui enfermaria?" },
  { key: "possuiAcademia", label: "Possui academia?" },
  { key: "atualizacaoAcomodacao", label: "Data Atualização Acomodações", format: formatDetailDate },
];

/** As 4 colunas da tabela, na ordem do AC3. */
export const ACOMODACOES_COLUMNS: readonly {
  readonly field: keyof EmbarcacaoAcomodacaoTipo;
  readonly header: string;
}[] = [
  { field: "tipo", header: "Tipo de acomodação" },
  { field: "quantidade", header: "Quantidade de acomodações" },
  { field: "quantoComporta", header: "Quanto comporta" },
  { field: "comentario", header: "Comentário" },
];

/** A tabela de tipos rola na horizontal abaixo desta largura. */
export const ACOMODACOES_TABLE_MIN_WIDTH = "40rem";
